import { Injectable, OnDestroy } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MessageType } from './message-type';

export interface UserMessage { id:number; type:MessageType; title:string; message:string; }
@Injectable({providedIn:'root'})
export class UserMessageService implements OnDestroy {
  private sequence = 0;
  private state = new BehaviorSubject<UserMessage[]>([]);
  readonly messages = this.state.asObservable();
  private navigation: Subscription;
  constructor(router: Router) {
    this.navigation = router.events.subscribe(event => { if (event instanceof NavigationStart) this.clear(); });
  }
  show(message:string, type:MessageType='info', title='') {
    const item={id:++this.sequence,type,title,message};
    this.state.next([...this.state.value,item]);
    return item.id;
  }
  dismiss(id:number) { this.state.next(this.state.value.filter(item=>item.id!==id)); }
  clear() { this.state.next([]); }
  ngOnDestroy() { this.navigation.unsubscribe(); this.state.complete(); }
}
